module.exports = "<app-shipment-title *ngIf=\"summary\" class=\"block\" [shipment]=\"shipment\"\n  [showCircle]=\"false\"></app-shipment-title>\n<app-additional-costs *ngIf=\"additional\" class=\"block\" [shipment]=\"shipment\"></app-additional-costs>\n<app-shipment-status class=\"container\" [shipment]=\"shipment\"></app-shipment-status>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shipments/components/shipment-info/shipment-info.component.html
// module id = ./src/app/modules/shipments/components/shipment-info/shipment-info.component.html
// module chunks = main